import { ItemStore } from "@mobx/store/locations/interfaces";
import { Tooltip } from "antd";
import { TooltipPlacement } from "antd/es/tooltip";
import { observer } from "mobx-react-lite";
import { ReactNode, useEffect, useState } from "react";
import Menu3 from "../Menu3";

interface ITooltipMenu3Props {
  readonly itemStore: ItemStore;
  readonly children: ReactNode;
  readonly minerName?: string;
  readonly userId?: number;
  readonly minerId?: number;
  readonly placement?: TooltipPlacement;
}

const TooltipMenu3 = observer((props: ITooltipMenu3Props) => {
  const { children, minerName, userId, minerId } = props;
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    console.log("TooltipMenu3 is Open:", open);
  }, [open]);

  const onClose = () => {
    props.itemStore.rackStore.setReduced(true);
    setOpen(false);
  };
  const onOpen = () => {
    props.itemStore.rackStore.setReduced(false);
    setOpen(true);
  };

  const onClickContext = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.focus();
    onOpen();
  };

  useEffect(() => {
    const onTypeEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("keydown", onTypeEscape);
    return () => document.removeEventListener("keydown", onTypeEscape);
  }, []);

  return (
    <div onContextMenu={onClickContext}>
      <Tooltip
        trigger={"contextMenu"}
        color='#fff'
        placement={props.placement ?? "rightBottom"}
        title={
          <Menu3
            itemStore={props.itemStore}
            onCloseTooltip={onClose}
            userId={userId}
            minerName={minerName}
            minerId={minerId}
          />
        }
        styles={{
          body: {
            padding: 0
          }
        }}
        zIndex={2}
        open={open}
        destroyOnHidden
      >
        {children}
      </Tooltip>
    </div>
  );
});

TooltipMenu3.displayName = "TooltipMenu3";

export default TooltipMenu3;
